import React from "react";

import { ValidatedForm, MFile } from "components/forms";

import {
  payloadBuilder,
  networkErrorHelper,
  notNullObjectBuilder,
  adminService,
} from "libs";

import dayjs from "dayjs";

import { Card, CardBody, Button } from "design-react-kit";
import { ErrorNotification, MnemoLoading } from "components/misc";

export class AdminLessonTrainingAnalyticsForm extends ValidatedForm {
  emptyFields = {
    webexAnalytics: this.props.idLessonTrainingSchedule,
    slidoAnalytics: this.props.idLessonTrainingSchedule,
    document: this.props.idLessonTrainingSchedule,
  };

  FIELDS_GROUP = [
    [
      {
        id: "document",
        field: "document",
        label: "Report partecipazione Webex",
        infoText: "Caricare il report attività Webex",
        component: MFile,
        config: {
          endPoint: "/admin/lessonTrainingAnalytics/webex-file",
          fieldName: "document",
          maxFiles: 1,
          accept: ".csv",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "document",
        field: "document",
        label: "Report risposte slido, chat, etc",
        infoText: "Caricare il report risposte slido, le chat, etc",
        component: MFile,
        config: {
          endPoint: "/admin/lessonTrainingAnalytics/slido-file",
          fieldName: "document",
          maxFiles: 5,
          accept: ".xlsx,.txt,.csv",
        },
        className: "col-md-12",
      },
    ],
  ];

  //--- ---

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      ...this.emptyFields,
      defaultValues: {
        document: this.props.idLessonTrainingSchedule,
        webexAnalytics: this.props.idLessonTrainingSchedule,
        slidoAnalytics: this.props.idLessonTrainingSchedule,
      },
      formActive: true,
      idLessonTrainingSchedule: this.props.idLessonTrainingSchedule,
      webexImported: false,
    };

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote(additionalState = {}) {
    //--- prevent loadRemote when not required ---
    if (parseInt(this.props.idLessonTrainingSchedule) <= 0) {
      return false;
    }

    let filter = {
      searchFilter: {
        id: parseInt(this.props.idLessonTrainingSchedule),
      },
    };

    adminService
      .loadTrainingSchedule(filter)
      .then(({ data }) => {
        //--- force date format to date ---
        data.payload.trainingSchedule.date = dayjs(
          data.payload.trainingSchedule.date
        ).format("YYYY-MM-DD");

        const defaultValues = notNullObjectBuilder(
          this.emptyFields,
          data.payload.trainingSchedule
        );

        const newState = {
          defaultValues,
          ...additionalState,
          loading: false,
          trainingSchedule: data.payload.trainingSchedule,
        };

        this.setState(newState);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  } //loadremote

  onCancel = () => {
    this.resetForm();
  }; //onCancel

  onBackPage = () => {
    window.history.back();
  };

  saveRemote = () => {
    payloadBuilder(this.state);
  };

  importWebex = () => {
    this.setState({ loading: true });
    adminService
      .insertLessonTrainingAnalyticsWebex(this.state.idLessonTrainingSchedule)
      .then(({ data }) => {
        ErrorNotification.render(
          "Analizzati " + data.payload.imported + " attività",
          "success"
        );
        this.setState({
          loading: false,
          trainingSchedule: data.payload.trainingSchedule,
        });
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  };

  disableAttendance = () => {
    this.setState({ loading: true });
    adminService
      .disableAttendance(this.state.idLessonTrainingSchedule)
      .then(({ data }) => {
        this.setState({
          loading: false,
          trainingSchedule: data.payload.trainingSchedule,
        });
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  };

  enableAttendance = () => {
    this.setState({ loading: true });
    adminService
      .enableAttendanceTraining(this.state.idLessonTrainingSchedule)
      .then(({ data }) => {
        this.setState({
          loading: false,
          trainingSchedule: data.payload.trainingSchedule,
        });
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  };

  importSlido = () => {
    this.setState({ loading: true });
    adminService
      .insertLessonLiveAnalyticsWebex(this.state.idLessonTrainingSchedule)
      .then(({ data }) => {
        this.setState({ loading: false });
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  };

  render() {
    let { formActive, defaultValues, loading, trainingSchedule } = this.state;
    const { code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    const enabled = trainingSchedule
      ? trainingSchedule.enableAttendance
      : false;

    return (
      <>
        {loading && <MnemoLoading />}
        <Card
          tag="div"
          className="card-bg card-big rounded shadow border-bottom-card"
        >
          <div className="flag-icon" />
          <CardBody tag="div">
            <form className="user" id="analyticsForm">
              {code}
            </form>

            <hr />

            <div className="mt-4">
              <Button color="primary bg-dark" onClick={this.importWebex}>
                Analizza report attività webex{" "}
              </Button>
              {enabled ? (
                <Button
                  color="primary bg-dark"
                  className="mx-4"
                  onClick={this.disableAttendance}
                >
                  Disabilita download attestati
                </Button>
              ) : (
                <Button
                  color="primary bg-dark"
                  className="mx-4"
                  onClick={this.enableAttendance}
                >
                  Abilita download attestati
                </Button>
              )}
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}
